import React from 'react';
import parseLastSeen from '../../utils/parseLastSeen';

import { CamerasCell } from '..';
import './MonitorRow.scss';

const MonitorRow = ({ monitor, cameras, isNewMonitor, index }) => {
  const { name, lastSeen, status } = monitor;

  return (
    <div className={`${isNewMonitor ? "monitor-row monitor-row--new" : "monitor-row"}`} style={{ animationDelay: `${index * 250}ms` }}>
      <span>{name}</span>
      <span style={{ color: status === "online" ? '#02a402' : "#cc0026" }}>{status}</span>
      <span>{parseLastSeen(lastSeen)}</span>
      {cameras && <CamerasCell cameras={cameras}/>}
    </div>
  )
}

export default MonitorRow;